import { graphql } from "react-relay";

export const DeliverNotificationRuleMutation = graphql`
  mutation DeliverNotificationRuleMutation(
    $input: DeliverNotificationRuleInput!
  ) {
    deliverNotificationRule(input: $input) {
      problems {
        message
      }
    }
  }
`;
